export default {"src":"/_next/static/media/google.cd0c9ffc.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};